import {useState} from 'react';

import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';

import ReferrerForm from './ReferrerForm';

const CreateReferrerButton = props => {
  const [isOpen, setIsOpen] = useState(false);
  const onClose = () => setIsOpen(false);
  const afterSubmit = (e, id) => {
    onClose();
    if (props.afterSubmit) props.afterSubmit(e, id);
  };
  return (
    <>
      <Dialog 
        open={isOpen} 
        onClose={onClose}
        maxWidth='small'
      >
        <Stack direction='row' justifyContent='flex-end' alignItems='center'>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Stack>
        <DialogContent>
          <ReferrerForm afterSubmit={afterSubmit} />
        </DialogContent>
      </Dialog>
      <Button 
        size={props.size || 'small'} 
        onClick={() => setIsOpen(true)}
      >
        <AddIcon />
        {props?.label || 'Create New'}
      </Button>
    </>
  );
};

export default CreateReferrerButton;